<header
  *ngIf="menuState$ | async as menuState"
  [ngClass]="{ open: menuState.isMenuOpen }"
>
  <button
    class="menu-button"
    mat-icon-button
    (click)="toggleMenuVisibility(menuState.isMenuOpen)"
    title="Abrir menu de serviços"
  >
    <mat-icon>{{ menuState.isMenuOpen ? 'clear' : 'menu' }}</mat-icon>
  </button>

  <h1>
    <span>Brasilprev</span>
    <button (click)="navigateTo('/home')" [title]="buttonTextEnum.GO_HOME">
      <img
        src="../../../../assets/svg/brasilprev-new.svg"
        alt="logo BrasilPrev"
        role="button"
        aria-label="logo brasilprev"
      />
    </button>
  </h1>

  <div class="profile-and-search-container">
    <ng-container *ngIf="selectedPlanData$ | async as planData">
      <div *ngIf="planData.registration" class="search-button-container">
        <button mat-flat-button (click)="openSearchContainer()">
          <mat-icon svgIcon="mobile-bottom-navigation__search"></mat-icon>
        </button>
      </div>
    </ng-container>
    <app-profile-menu
      *ngIf="profileMenuItems$ | async as profileMenuItems"
      [nameInitials]="nameInitials"
      [isProfileOpen]="menuState.isProfileOpen"
      [navigationList]="profileMenuItems"
    ></app-profile-menu>
  </div>

  <app-header-navigation
    [isMenuOpen]="menuState.isMenuOpen"
  ></app-header-navigation>
</header>

<app-desktop-search-container></app-desktop-search-container>
